export const Svg_120 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M17.5 65.625 14 63l7.583-10.136L21 38.937c-.098-2.48.036-5.128.4-7.948.365-2.82.936-5.298 1.714-7.437l-7.073 4.083v8.094h-4.375V25.083l12.177-7c.827-.486 1.629-.85 2.407-1.094a7.561 7.561 0 0 1 2.26-.364c1.167 0 2.2.28 3.099.838.9.56 1.568 1.373 2.005 2.443l1.896 4.302c.924 2.09 2.698 3.804 5.323 5.14 2.625 1.337 5.542 2.006 8.75 2.006v4.375h-3.354L62.927 64.53l-1.896 1.094-17.646-30.48c-2.042-.486-4.144-1.47-6.307-2.953-2.164-1.482-3.804-3.099-4.922-4.849a31.417 31.417 0 0 0-1.35 5.36c-.315 1.92-.425 3.658-.327 5.213l7.073 9.99v17.719h-4.375v-15.97l-6.198-6.926-.73 11.229-8.75 11.667Zm15.895-52.063c-1.458 0-2.71-.522-3.755-1.568-1.045-1.045-1.567-2.296-1.567-3.755 0-1.458.522-2.71 1.567-3.755s2.297-1.568 3.755-1.568c1.459 0 2.71.523 3.756 1.568 1.045 1.045 1.567 2.297 1.567 3.755 0 1.459-.522 2.71-1.567 3.755-1.046 1.046-2.297 1.568-3.756 1.568Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={23.52}
        x2={55.563}
        y1={12.322}
        y2={54.714}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)